import { call, put } from 'redux-saga/effects';
import {
  changeSidebarType as changeSidebarTypeAction,
  changeTopbarTheme as changeTopbarThemeAction,
} from '../../actions/layout';

/**
 * Changes the body attribute
 */
function changeBodyAttribute(attribute, value) {
  if (document.body) document.body.setAttribute(attribute, value);
  return true;
}

/**
 * Toggle the class on body
 * @param {string} cssClass - CSS class to toggle
 * @param {string} action - Action to perform: 'add', 'remove', or 'toggle'
 */
function manageBodyClass(cssClass, action = 'toggle') {
  if (!document.body) return false;
  
  switch (action) {
    case 'add':
      document.body.classList.add(cssClass);
      break;
    case 'remove':
      document.body.classList.remove(cssClass);
      break;
    default:
      document.body.classList.toggle(cssClass);
      break;
  }
  return true;
}

/**
 * Changes the layout type
 * @param {Object} action - Redux action
 */
export function* changeLayoutWorker(action) {
  try {
    if (action.payload === 'horizontal') {
      yield put(changeTopbarThemeAction('dark'));
      document.body.removeAttribute('data-sidebar');
      document.body.removeAttribute('data-sidebar-size');
    } else {
      yield put(changeTopbarThemeAction('light'));
    }
    yield call(changeBodyAttribute, 'data-layout', action.payload);
  } catch (error) {
    console.error('Error in changeLayoutWorker:', error);
  }
}

/**
 * Changes the layout width
 * @param {Object} action - Redux action
 */
export function* changeLayoutWidthWorker(action) {
  try {
    if (action.payload === 'boxed') {
      yield put(changeSidebarTypeAction('icon'));
      yield call(changeBodyAttribute, 'data-layout-size', action.payload);
    } else {
      yield put(changeSidebarTypeAction('default'));
      yield call(changeBodyAttribute, 'data-layout-size', action.payload);
    }
  } catch (error) {
    console.error('Error in changeLayoutWidthWorker:', error);
  }
}

/**
 * Changes the left sidebar theme
 * @param {Object} action - Redux action
 */
export function* changeLeftSidebarThemeWorker(action) {
  try {
    yield call(changeBodyAttribute, 'data-sidebar', action.payload);
  } catch (error) {
    console.error('Error in changeLeftSidebarThemeWorker:', error);
  }
}

/**
 * Changes the body theme
 * @param {Object} action - Redux action
 */
export function* changeBodyThemeWorker(action) {
  try {
    yield call(changeBodyAttribute, 'data-bs-theme', action.payload);
  } catch (error) {
    console.error('Error in changeBodyThemeWorker:', error);
  }
}

/**
 * Changes the left sidebar type
 * @param {Object} action - Redux action
 */
export function* changeLeftSidebarTypeWorker(action) {
  try {
    const { sidebarType, isMobile } = action.payload;
    
    if (isMobile) {
      yield call(manageBodyClass, 'sidebar-enable', 'remove');
      yield call(manageBodyClass, 'vertical-collpsed', 'remove');
      yield call(manageBodyClass, 'sidebar-enable', 'add');
      return;
    }

    switch (sidebarType) {
      case 'compact':
        yield call(manageBodyClass, 'vertical-collpsed', 'toggle');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        break;
      case 'icon':
        yield call(manageBodyClass, 'vertical-sidebar-enable', 'toggle');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        break;
      case 'condensed':
        yield call(manageBodyClass, 'sidebar-enable', 'add');
        break;
      default:
        yield call(manageBodyClass, 'vertical-collpsed', 'remove');
        yield call(manageBodyClass, 'sidebar-enable', 'remove');
        yield call(manageBodyClass, 'vertical-sidebar-enable', 'remove');
        break;
    }
  } catch (error) {
    console.error('Error in changeLeftSidebarTypeWorker:', error);
  }
}

/**
 * Changes the topbar theme
 * @param {Object} action - Redux action
 */
export function* changeTopbarThemeWorker(action) {
  try {
    yield call(changeBodyAttribute, 'data-topbar', action.payload);
  } catch (error) {
    console.error('Error in changeTopbarThemeWorker:', error);
  }
}

/**
 * Shows the right sidebar
 */
export function* showRightSidebarWorker() {
  try {
    yield call(manageBodyClass, 'right-bar-enabled', 'toggle');
  } catch (error) {
    console.error('Error in showRightSidebarWorker:', error);
  }
}
